export function openKakaoPage() {
  window.open(process.env.KAKAO_MOBILE_PAGE_URL);
}
